export const stateStrategy = {
  registered: 'registered',
  qualifying: 'qualifying',
  qualifying_management_review: 'qualifying',
  qualifying_approved: 'qualifying',
  in_bidding: 'certame',
  contracting: 'negotiating',
  contracting_management_review: 'negotiating',
  contracting_finalization: 'implantation',
  completed: 'completed',
} as const

export const translateStateStrategy = {
  registered: 'Registrado',
  qualifying: 'Qualificando',
  certame: 'Certame',
  negotiating: 'Contrato',
  implantation: 'Implantação',
  completed: 'Concluído',
}

export const contactStateStrategy = {
  pending: 'pending',
  awaiting_client_documents: 'awaiting_client_documents',
  in_review: 'in_review',
  complete: 'complete',
} as const

export const translateContactStateStrategy = {
  pending: 'Pendente',
  awaiting_client_documents: 'Aguardando Resposta',
  in_review: 'Revisar',
  complete: 'Completo',
}
